import { Typography } from "@mui/material";
import "../BranchManagement/BranchManagement.css";
import "./GlobalSettings.css";

const auditColumns = [
  { key: "when", label: "When" },
  { key: "who", label: "Who" },
  { key: "change", label: "Change" },
  { key: "from", label: "From" },
  { key: "to", label: "To" },
];

const auditLogsData = [
  {
    when: "20 Aug, 4:12 PM",
    who: "R. Anand (Owner)",
    change: "Refund approval — Tier 2 max raised",
    from: "₹8,000",
    to: "₹10,000",
  },
  {
    when: "19 Aug, 11:02 AM",
    who: "Supervet (Admin)",
    change: "Front Desk role — Billing access",
    from: "Read only",
    to: "Read & write",
  },
  {
    when: "18 Aug, 6:45 PM",
    who: "R. Anand (Owner)",
    change: "Appointment auto-close window",
    from: "5 days",
    to: "3 days",
  },
  {
    when: "17 Aug, 9:30 AM",
    who: "Supervet (Admin)",
    change: "WhatsApp routing — Invoice & Receipt",
    from: "Off",
    to: "On",
  },
  {
    when: "15 Aug, 2:18 PM",
    who: "R. Anand (Owner)",
    change: "Stock adjustment approver",
    from: "Practice Manager",
    to: "Practice Manager, Sanjai",
  },
];

const AuditLogSettings = () => {
  return (
    <div className="consultation-white-con scroll-80vh p20">
      <div className="mb20 pb10 border-bottom">
        <Typography className="text-bold fs20 black">Audit Log</Typography>
        <Typography className="txt-regular fs13 card-gray-color mt4">
          Every settings change on this page, who made it, and when.
        </Typography>
      </div>

      <div className="al-table-card">
        <table className="al-table">
          <thead>
            <tr>
              {auditColumns.map((col) => (
                <th key={col.key}>{col.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {auditLogsData.map((row, index) => (
              <tr key={`${row.when}-${index}`}>
                <td className="al-when">{row.when}</td>
                <td className="al-who">{row.who}</td>
                <td className="al-change">{row.change}</td>
                <td className="al-from">{row.from}</td>
                <td className="al-to">{row.to}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditLogSettings;
